const RoutesConstant = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD_FIRST_LOGIN: "/reset-password-first-login",
  PARENTFORM: "/parent-form-admin",
  DASHBOARD: "/",
  INSTITUTIONS: "/institutions",
  INSTITUTION_OWNERS: "/institution-owners",
  PRODUCT_DEMO: "/product-demo",
  PUBLISH_PARENT_FORM: "/publish-parent-form",
  SCHOOL_STATISTICS: "/school-statistics",
  STUDENTS: "/students",
  STUDENT_DETAILS: "/student-details",
  STUDENT_FORM: "/student-form",
  STAFF: "/staff",
  USER_ROLE_MANAGEMENT: "/user-role-management",
  SETTINGS: "/settings",
  INSTITUTION_DETAILS: "/institution-details",
  INSTITUTION_FORM: "/institution-form",
  STUDENT_LIST: "/student-list",
  TEACHERS: "/teachers",
  TEACHER_LIST: "/teacher-list",
  TEACHER_DETAILS: "/teacher-details",
  TEACHER_FORM: "/teacher-form",
  SUBJECTS: "/subjects",
  ATTENDANCE_REGISTER: "/attendance-register",
  SETUP_CLASS_ROUTINE: "/setup-class-routine",
  SCHOOL_INFORMATION: "/school-information",
  SCHEDULE_EXAMINATION: "/schedule-examination",
  REPORT_CARD_MANAGEMENT: "/report-card-management",
  ANNOUNCEMENT: "/announcement",
  CHAT: "/chat",
  HOLIDAY_LEAVE: "/holiday-leave",
  TEACHER_ATTENDANCE: "/teacher-attendance",
  STUDENT_ATTENDANCE: "/student-attendance",
  NEWSLETTER: "/newsletter",
  NEWSLETTER_FORM: "/newsletter-form",
  SUPPORT: "/support",
  SUPPORT_CHAT: '/support-chat',
  CUSTOMER_SUPPORT: '/customer-support',
  EVENT: "/event",
  CONTACT_QUERIES: "/contact-queries",
  STUDENT_PROMOTION: "/student-promotion",
};

export default RoutesConstant;
